import { render, staticRenderFns } from "./originData.vue?vue&type=template&id=ab269fba&scoped=true"
import script from "./originData.vue?vue&type=script&lang=js"
export * from "./originData.vue?vue&type=script&lang=js"
import style0 from "./originData.vue?vue&type=style&index=0&id=ab269fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab269fba",
  null
  
)

export default component.exports